var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5585 24.7822C18.5202 25.7439 18.5202 27.3925 17.5585 28.3542L15.5665 30.3462C14.6048 31.3079 12.9562 31.3079 11.9945 30.3462L0.721268 19.0041C-0.240423 18.0424 -0.240423 16.3938 0.721268 15.4321L2.71334 13.44C3.67503 12.4783 5.32365 12.4783 6.28534 13.44L17.5585 24.7822Z",
    fill: "#407BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9032 0.881424C34.8649 -0.0802663 36.5135 -0.0802663 37.4752 0.881424L39.4673 2.8735C40.429 3.83519 40.429 5.4838 39.4673 6.44549L15.6349 30.2088C14.6733 31.1705 13.0246 31.1705 12.063 30.2088L10.0709 28.2167C9.10919 27.255 9.10919 25.6064 10.0709 24.6447L33.9032 0.881424Z",
    fill: "#407BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blue-tick.7d0c7b57e86cb54cd48e1e2e7b004c9d.svg";
export { ForwardRef as ReactComponent };